import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../baseApiService';
import { AuthenticationService } from '../../auth/authentication-service';
import { EditRegistrationCommand } from './editRegistrationCommand';
import { CreateRegistrationCommand } from './createRegistrationCommand';
import { Registration } from './registration';
import { RegistrationsImportResponse } from './registrationsImportResponse';

@Injectable({
  providedIn: 'root'
})
export class RegistrationApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getRegistration(registrationId: number): Observable<Registration> {
    return this.http.get<Registration>(`${this.apiUrl}/api/v6/registrations/${registrationId}`).pipe(
      catchError(this.handleError<Registration>('getRegistration', undefined))
    );
  }

  createRegistration(createRegistrationCommand: CreateRegistrationCommand): Observable<Registration> {
    return this.http.post<Registration>(`${this.apiUrl}/api/v6/registrations/register-asset`, createRegistrationCommand);
  }

  updateRegistration(id: number, editRegistrationCommand: EditRegistrationCommand): Observable<Registration> {
    return this.http.put<Registration>(`${this.apiUrl}/api/v6/registrations/${id}`, editRegistrationCommand);
  }

  getRegistrationsForAsset(assetIds: string): Observable<Registration[]> {
    if (!assetIds.trim()) {
      return of();
    }

    return this.http.get<Registration[]>(`${this.apiUrl}/api/v6/registrations/by-asset-ids/${assetIds}`).pipe(
      catchError(this.handleError<Registration[]>('getRegistrationsForAsset', undefined))
    );
  }
  
  importRegistrations(formData: FormData): Observable<RegistrationsImportResponse> {
    return this.http.post<RegistrationsImportResponse>(`${this.apiUrl}/api/v6/registrations/import`, formData);
  }
}
